// tslint:disable no-bitwise
import isValidColor from './colorValidations'

export default function isTooDark(colorToAnalyze: string): boolean | undefined {
    if (!colorToAnalyze || typeof colorToAnalyze === 'undefined') {
        return true
    }

    const color = colorToAnalyze.trim()

    if (!isValidColor(color)) {
        return
    }

    // Variables for red, green, blue values
    let r: number
    let g: number
    let b: number

    // Constants for P (Perceived Brightness), one for each color
    const PR = 0.299
    const PG = 0.587
    const PB = 0.114

    // Color Threshold
    const THRESHOLD = 127.5

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        const colorComponents = color.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        )

        if (!colorComponents) {
            return
        }

        const RADIX = 10

        r = parseInt(colorComponents[1], RADIX)
        g = parseInt(colorComponents[2], RADIX)
        b = parseInt(colorComponents[3], RADIX)
    } else {
        // If HEX --> Convert it to RGB: http://gist.github.com/983661
        const colorComponents = +`0x${color
            .slice(1)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            .replace(color.length < 5 && /./g, '$&$&')}`

        r = colorComponents >> 16
        g = (colorComponents >> 8) & 255
        b = colorComponents & 255
    }

    // HSP (Hue Saturation Perceived brightness) equation from https://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(PR * (r * r) + PG * (g * g) + PB * (b * b))

    // if hsp is lower than the value, it returns true
    return hsp <= THRESHOLD
}
